import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import axios from "axios";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import CustomNavbar from "../CustomPermissions/CustomNavbar";

import { getApiUrl, API_ENDPOINTS, API_BASE_URL } from "../../config/api";

function ShowPrevMonthTeamLeader({ prop }) {
  const location = useLocation();
  const stateValue = location.state && location.state["newUser"];

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchLeaders() {
      try {
        const response = await fetch(
          getApiUrl("/LeadersTable/leaders_table_prev_month_record/", false),
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        if (!response.ok) {
          throw new Error("Failed to fetch leaders");
        }
        const data = await response.json();
        setData(data.leaders);
        setLoading(false);
      } catch (error) {
        console.error(error);
        setLoading(false);
      }
    }
    fetchLeaders();
  }, []);

  return (
    <div className="flex">
      <CustomNavbar className="bg-blue-500 p-4 text-white" />
      <section
        className="flex-grow overflow-auto"
        style={{ width: "100%", auto: "auto" }}
      >
        <div className="bg-white shadow-md rounded-lg p-4">
          {loading ? (
            <div className="text-center py-6 text-blue-600 font-semibold">
              Loading...
            </div>
          ) : (
            <>
              <h2 className="text-2xl font-bold text-blue-600 mb-4">
                Team Leader's Last Month Record
              </h2>
              <table className="w-full border-collapse">
                <thead>
                  <tr className="bg-blue-500 text-white">
                    <th className="p-2 w-5">Rank</th>
                    <th className="p-2 w-10">Image</th>
                    <th className="p-2 w-12">Name</th>
                    <th className="p-2 w-48">Percentage</th>
                    <th className="p-2 w-48">Action</th>

                  </tr>
                </thead>

                <tbody>
                  {data &&
                    data.map((record, index) => (
                      <tr key={record.id} className="border-b">
                        <td className="p-2 text-center">{index + 1}</td>
                        <td className="p-2">
                          <img
                            src={`${API_BASE_URL}${record.image}`}
                            // className="h-20 w-16 rounded-full object-cover"
                            style={{ width: "200px", height: "120px" }}
                            alt={record.name}
                          />
                        </td>
                        <td className="p-2 text-center">{record.name}</td>
                        <td className="p-2 text-center">
                          <div className="relative w-full h-6 bg-gray-200 rounded-md overflow-hidden">
                            <div
                              className={`h-full ${
                                record.calculatePercentage >= 100
                                  ? "bg-blue-600"
                                  : record.calculatePercentage >= 95
                                  ? "bg-green-500"
                                  : record.calculatePercentage >= 85
                                  ? "bg-yellow-500"
                                  : "bg-red-500"
                              }`}
                              style={{
                                width: `${Math.min(record.calculatePercentage, 100)}%`,
                              }}
                            ></div>
                          </div>
                          <span 
                            className={`text-sm font-semibold ${
                              record.calculatePercentage >= 100
                                ? "text-blue-600"
                                : record.calculatePercentage >= 95
                                ? "text-green-500"
                                : record.calculatePercentage >= 85
                                ? "text-yellow-500"
                                : "text-red-500"
                            }`}
                          >
                            {Math.ceil(record.calculatePercentage)}%
                          </span>
                        </td>
                        <td className="p-2 text-center flex flex-col gap-1">
                          {/* <Link
                            to={`/currentmonthTaskForm/${record.id}`}
                            className="text-blue-600 hover:underline"
                          >
                            Add Task
                          </Link> */}
                          {/* <Link
                            to={`/leadersTask/${record.id}`}
                            className="text-blue-600 hover:underline"
                          >
                            View Task
                          </Link> */}
                          <Link
                            to={`/leadersOldRecords/${record.id}`}
                            className="text-blue-600 hover:underline"
                          >
                            Old Month Records
                          </Link>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </>
          )}
        </div>
      </section>
    </div>
  );
}
export default ShowPrevMonthTeamLeader;
